import request from './request'

export function listStaffWorkTime(data) {
  return request.post('/production/staff-work-times/list', data)
}
export function clockIn(data) {
  return request.post('/production/staff-work-times/clock-in', data)
}
export function clockOut(data) {
  return request.post('/production/staff-work-times/clock-out', data)
}
export function deleteStaffWorkTime(ids) {
  return request.post('/production/staff-work-times/delete', ids)
}
